export default "__VITE_ASSET__Brbpv3nH__"